export const noteTypes = {
    productionOrders: "production_orders"
}